export default __webpack_public_path__ + "static/imageonline-co-roundcorner-b5fd5f8a0e28f8567075616999acbea0.png";